import { Root } from 'react-dom/client';
import { AddBizReactLoader } from '../../Js/React/loader';
import ObjectMiniList, { ListObject, ObjectType } from './ObjectMiniList';
import BizUnsplashCredits from '../../FrontEndReact/src/Core/Components/BizMediabank/BizUnsplashCredits';
import { BizAgentWidget } from '../../FrontEndReact/src/Modules/BizAgent';
import Chat from '../../FrontEndReact/src/Modules/Chat/Chat';
import { withFrontendContext } from '../Common/frontendStateContext';
import BadgeList from '../../FrontEndReact/src/Core/Components/Badge/BadgeList';
import BizExperiencePoints from '../../FrontEndReact/src/Core/Components/Mini/BizExperiencePoints';
import { BizToplist, ToplistConfig } from '../../FrontEndReact/src/Core/Components/Toplist';

const addLoader = (e) => {
	console.log('ObjectMiniList', e);
	const params = (
		e.detail as {
			params: {
				objects: ListObject[];
				limit: number;
				itemsPerRow?: number;
				type?: string;
				layout?: string;
				layoutMobile?: string;
			};
		}
	).params;

	const parseType = (type: string | undefined): ObjectType | undefined => {
		if (!type) return undefined;
		return type.toUpperCase() as ObjectType;
	};

	const type = parseType(params.type);

	return (
		<ObjectMiniList
			objects={params.objects}
			limit={params.limit}
			itemsPerRow={params.itemsPerRow}
			type={type}
			layout={params.layout}
			layoutMobile={params.layoutMobile}
		/>
	);
};

let root: Root | undefined;
AddBizReactLoader(root, 'bizobjectminilist_blog', addLoader);
AddBizReactLoader(root, 'bizobjectminilist_media', addLoader);
AddBizReactLoader(root, 'bizobjectminilist_education', addLoader);
AddBizReactLoader(root, 'bizobjectminilist_start_journey', addLoader);
AddBizReactLoader(root, 'bizobjectminilist_start_journey_mobile', addLoader);

AddBizReactLoader(root, 'bizunsplashcredits', (e) => {
	const params = (e.detail as { params: { imageUrl: string } }).params;
	return <BizUnsplashCredits imageUrl={params.imageUrl} />;
});

AddBizReactLoader(root, 'bizagentwidget', (e) => {
	const params = (e.detail as { params: { configSystemName: string; inlineMode: boolean } }).params;
	return withFrontendContext(<BizAgentWidget configSystemName={params.configSystemName} inlineMode={params.inlineMode} />);
});

AddBizReactLoader(root, 'bizchat', (e) => {
	const params = (e.detail as { params: { dmToUserId?: number } }).params;
	return withFrontendContext(<Chat initDMToUserId={params?.dmToUserId} autoSetFocus={true} />);
});

AddBizReactLoader(root, 'bizprofilebadges', () => {
	return withFrontendContext(<BadgeList />);
});

AddBizReactLoader(root, 'bizcountup', () => {
	return withFrontendContext(<BizExperiencePoints legacy={true} />);
});

AddBizReactLoader(root, 'biztoplist_start', (e) => {
	const params = (e.detail as { params: { limit?: number } }).params;
	const config = getStartPageToplistConfig();
	return withFrontendContext(<BizToplist legacy config={config} />);

	function getStartPageToplistConfig(): ToplistConfig {
		const now = new Date();
		const currentYear = now.getFullYear();
		const currentMonth = now.getMonth();

		// Start of current month
		const startOfMonth = new Date(currentYear, currentMonth, 1);

		// End of today (23:59:59)
		const endOfToday = new Date(currentYear, currentMonth, now.getDate(), 23, 59, 59);

		return {
			scope: 'unit',
			fromDate: startOfMonth,
			toDate: endOfToday,
			limit: params.limit ?? 10,
		};
	}
});
